import {SET_CURRENT_EDITED_BOOK, RESET_EDITED_BOOK} from "./actionTypes";

export const currentBookEdited = (bookId) => {
    return {
        type: SET_CURRENT_EDITED_BOOK,
        payload: bookId
    }
}

export const resetEditedBook = () => {
    return {
        type: RESET_EDITED_BOOK
    }
}